import { createContext, useState } from 'react'

import type { IInputPasswordProps } from '../types'

export interface InputPasswordPropsProviderProps extends IInputPasswordProps {
  children: React.ReactNode
  value: string
}

export interface InputPasswordContextProps
  extends Omit<IInputPasswordProps, 'children'> {
  isActive: boolean
  setIsActive: (value: boolean) => void
  inputValue: string
  isFilled: boolean
  isHidden: boolean
  setIsHidden: (value: boolean) => void
  value: string
}

export const InputPasswordContext = createContext<InputPasswordContextProps>({
  isActive: false,
  setIsActive: (value: boolean) => {},
  inputValue: '',
  isFilled: false,
  isHidden: true,
  setIsHidden: (value: boolean) => {},
  errorText: '',
  value: '',
})

const { Provider } = InputPasswordContext

export function InputPasswordProvider({
  children,
  value,
  ...props
}: InputPasswordPropsProviderProps) {
  const [isActive, setIsActive] = useState(false)
  const [isHidden, setIsHidden] = useState(true)

  const customProps = {
    ...props,
    isActive,
    setIsActive,
    isHidden,
    setIsHidden,
    inputValue: value,
    isFilled: value.length > 0,
    value,
  }
  return <Provider value={{ ...customProps }}>{children}</Provider>
}
